import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import SocietaBenefitSection from '../components/SocietaBenefitSection';
import EticaproSection from '../components/EticaproSection';
import TeamSection from '../components/TeamSection';
import ProblemaSection from '../components/ProblemaSection';
import SoluzioneSection from '../components/SoluzioneSection';
import BeneficiSection from '../components/BeneficiSection';
import SocialProofSection from '../components/SocialProofSection';
import ImpactCounter from '../components/ImpactCounter';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import { Toaster } from '../components/ui/sonner';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <SocietaBenefitSection />
      <EticaproSection />
      <TeamSection />
      <ProblemaSection />
      <SoluzioneSection />
      <BeneficiSection />
      <SocialProofSection />
      <ContactForm />
      <ImpactCounter />
      <Footer />
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default Home;
